import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';

import { AlertController, NavController, ToastController } from 'ionic-angular';
import {projectNumber} from '../../model/index';

declare var dataLayer: Array<any>;


@Component({
  selector: 'page-user',
  templateUrl: 'support.html'
})
export class SupportPage {

  submitted: boolean = false;
  supportMessage: string;
  supportID: projectNumber;

  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController
  ) {

  }

  ionViewDidEnter() {
    let toast = this.toastCtrl.create({
      message: 'This does not actually send a support request.',
      duration: 3000
    });
    toast.present();
  }

  submit(form: NgForm) {
    this.submitted = true;
    this.supportID.getProjectNo(new Date(), 1);
    if (form.valid) {
      this.supportMessage = '';
      this.submitted = false;

      let toast = this.toastCtrl.create({
        message: 'Your support request has been sent. Support Request: '+ this.supportID ,
        duration: 3000
      });
      toast.present();

      dataLayer.push({
        'appEventCategory': 'user',
        'appEventAction': 'supportRequest',
        'appEventLabel': 'supportRequest'
      });
      dataLayer.push({'event': 'appEvent'});
    } else {
      dataLayer.push({
        'appEventCategory': 'user',
        'appEventAction': 'supportRequest Failure',
        'appEventLabel': 'supportRequest Failure'
      });
      dataLayer.push({'event': 'appEvent'});
    }
  }

  // If the user enters text in the support question and then navigates
  // without submitting first, ask if they meant to leave the page
  ionViewCanLeave(): boolean | Promise<boolean> {
    // If the support message is empty we should just navigate
    if (!this.supportMessage || this.supportMessage.trim().length === 0) {

      dataLayer.push({
        'appEventCategory': 'user',
        'appEventAction': 'supportRequest empty',
        'appEventLabel': 'supportRequest empty'
      });
      dataLayer.push({'event': 'appEvent'});

      return true;
    }

    return new Promise((resolve: any, reject: any) => {
      let alert = this.alertCtrl.create({
        title: 'Leave this page?',
        message: 'Are you sure you want to leave this page? Your support message will not be submitted.'
      });
      alert.addButton({ text: 'Stay', handler: reject });
      alert.addButton({ text: 'Leave', role: 'cancel', handler: resolve });

      alert.present();
    });

    //TODO: not sure how to tag this with google tag manager
  }

  ionViewDidLoad() {
    dataLayer.push({
      'screenPath': 'user',
      'screenName': 'SupportPage'
    });
    dataLayer.push({'event': 'appScreenView'});
  }
}



// WEBPACK FOOTER //
// ./src/pages/support/support.ts